import { Injectable } from '@angular/core';
import {map} from "rxjs";
import {ApiClass} from "../../../../../../data/class/api-class";

@Injectable({
  providedIn: 'root'
})
export class ApiCanvassingService extends ApiClass {

  constructor() {
    super()
    this.path = 'canvassing'
  }

  getAllCanvassing() {
    return this.getCollection().pipe(
      map((r) => r as { error: boolean; msg: string; data: any[] })
    );
  }
}
